import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLanguage } from "../reduxStore/dictionarySlice";

function LanguageBridgeWithWordpress() {
  const dispatch = useDispatch();

  useEffect(() => {
    const applyLanguage = (lang) => {
      if (!lang) return;
      dispatch(setLanguage(lang));
    };

    const savedLang = localStorage.getItem("siteLanguage");
    if (savedLang) {
      applyLanguage(savedLang);
    }

    const handleLanguageChange = (event) => {
      const lang = event.detail?.lang;
      applyLanguage(lang);
    };

    window.addEventListener("siteLanguageChange", handleLanguageChange);

    return () => {
      window.removeEventListener("siteLanguageChange", handleLanguageChange);
    };
  }, [dispatch]);

  return null;
}

export default LanguageBridgeWithWordpress;
